export type GuideAudience = "everyone" | "organizers" | "participants";

// Mirrors Guide#display_hash.
export interface Guide {
  id: number;
  title: string;
  slug: string;
  summary: string | null;
  audience: GuideAudience;
  position: number;
  published: boolean;
  body_html?: string;
}

// Mirrors Guide#edit_hash - raw Markdown, admin editor only.
export interface GuideDraft extends Omit<Guide, "body_html"> {
  body: string;
}

export const AUDIENCE_LABELS: Record<GuideAudience, string> = {
  everyone: "Everyone",
  organizers: "For organizers",
  participants: "For participants",
};
